import script from "./FooterVito.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterVito.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./FooterVito.vue?vue&type=style&index=0&id=5115e9aa&module=footerVito&lang=css"
cssModules["footerVito"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__